import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faRegularHeart } from "@fortawesome/free-regular-svg-icons";

import { useFontCartList } from "contexts/font.Context";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFontCartUpdate } from "contexts/font.Context";
import classNames from "classnames";

import "antd/dist/antd.less";

const Container = styled.div`
  position: relative;
  border: var(--fontBoxBorder);
  width: 335px;
  height: 311px;

  border-radius: 8px;
  border: 1px solid #dadce0;
  transition: all 0.18s ease;

  &:hover {
    color: white;
  }

  @media print {
    width: 167px;
    height: 149.5px;
  }

  scroll-snap-align: start;
`;

const FontButton = styled.div`
  width: 100%;
  height: 261px;
  color: #000000;
  font-size: ${(props) => (props.brush ? "70px" : "45px")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  border: 0px solid #eee;

  a:hover {
    color: #ffffff !important;
  }

  &:hover {
    background-color: rgba(66, 65, 65, 0.9);
    color: #ffffff;
  }

  @media print {
    height: 126.5px;
    font-size: ${(props) => (props.brush ? "40px" : "25px")};
  }

  display: flex;
  flex-direction: column;

  .header {
    display: flex;
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    font-family: "HYGothicM";
    top: 20px;
    left: 10px;
  }

  .fontCount {
    display: flex;
    position: absolute;
    left: 260px;
    width: 50px;
  }
`;


const FontName = styled.p`
  & > span {
    display: block;
    text-align: center;
  }
  font-family: ${(props) => props.webFontName};
  font-size: ${(props) => props.size}px;
  width: 95%;

  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;

  overflow: hidden;
  white-space: wrap;
  max-height: 180px;
  min-height: 60px;
  word-break: break-all;


  @media only screen and (max-width: 1400px) {    

   & > a {
    pointer-events: none;
    text-decoration: none;

    }


  }


`;

const FontType = styled.div`
  color: #8d8c87;
  font-size: 13px;

  display: flex;
  margin-left: 5px;

  height: 35px;
  border-top: var(--fontBoxBorder);
  justify-content: flex-start;
  align-items: center;

  @media print {
    height: 23px;
    font-size: 10px;
  }
  & > span > span.bold {
    font-weight: 600;
    color: black;
  }
  & > span > span.dot {
    display: inline-block;
    margin: 0 5px;
  }
  & > span > span.number {
    @media print {
      margin: 0 1px;
    }
  }

  .heart {
    position: absolute;
    right: 15px;
    color: red;
  }
`;

// const DownButton = styled.div`
//     width:13px;
//     height:14px;
//     margin-left:15px;
//     background-image:url(${down});
//     @media print {
//         display:none;
//     }
// `

const New = styled.div`
  background-color: #ed0000;
  width: 38px;
  height: 16px;
  position: absolute;
  top: 20px;
  right: 67px;
  color: white;
  border-radius: 8px;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: hy1148100116;
`;
const Add = styled(FontAwesomeIcon)`
  position: absolute;
  width: 20px;
  height: 20px;
  right: 15px;
  cursor: pointer;
  color: gray;
  &:hover {
    color: red;
  }
`;

export function useToggle(initValue = false) {
  const [value, setValue] = React.useState(initValue);

  const toggle = React.useCallback(() => {
    setValue((v) => !v);
  }, []);

  return [value, toggle];
}

const FontBox = ({
  id,
  type,
  familyname,
  webfont,
  isNew,
  font,
  family_type,
  sampleText,
  sampleSize }) => {

  const types = type.split(",");

  // console.log("sampleSize");
  // console.log(sampleSize);

  const { addCartFontList, removeCartFontFamily } = useFontCartUpdate();

  const [isOn, toggleIsOn] = useToggle();

  const showDefaultDrawer = () => {
    setSize("default");
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const [visible, setVisible] = useState(false);
  const [size, setSize] = useState();

  // 카트에 담기
  const addCart = () => {


    console.log(`cart click ${font.idx}`);
    console.log(font);

    toggleIsOn();
    showDefaultDrawer();
    isOn ? removeCartFontFamily(font.idx) : addCartFontList(font);
  };

  const typeString = (type) => {
    
    switch (type) {
      case "L":
        return "Light";
      case "M":
        return "Medium";
      case "B":
        return "Bold";
      case "E":
        return "Extra";
      case "EB":
        return "ExtraBold";
      default:
        return type;
    }
  };

  return (
    <Container>
      {isNew && isNew === "Y" ? <New>New</New> : ""}

      <FontButton>
        <div className="header">
          <div>{familyname}</div>
          <div className="fontCount"> {types?.length} 종</div>
        </div>
        <FontName style={{ fontFamily: `${webfont}` }} size={sampleSize} >
          <Link to={`/detail/${id}`}>
            {sampleText === "서체명" ? familyname : sampleText}
          </Link>
        </FontName>
      </FontButton>

      <FontType>
        <Add
          className={classNames("no-print", { heart: isOn })}
          icon={isOn ? faHeart : faRegularHeart}
          onClick={addCart}
          size="lg"
        />
      </FontType>
    </Container>
  );

}

export default FontBox;
